import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, ShoppingBag } from 'lucide-react';
import { useProfileStore } from '../store/profileStore';
import { ThemeToggle } from './ThemeToggle';
import { VacationToggle } from './VacationToggle';
import { SideMenu } from './SideMenu';

export function Header() {
  const [showSideMenu, setShowSideMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-40 h-14">
        <div className="absolute inset-0 bg-background/50 backdrop-blur-xl border-b border-border" />
        
        <div className="relative h-full">
          <div className="container mx-auto h-full px-2">
            <div className="flex items-center justify-between h-full">
              <div className="flex items-center gap-4">
                <button
                  onClick={() => setShowSideMenu(true)}
                  className="p-2 rounded-lg hover:bg-muted/50 transition-colors"
                >
                  <Menu className="w-5 h-5" />
                </button>
                <h1 className="text-lg font-bold">TODAY Move</h1>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => navigate('/shop')}
                  className="p-2 rounded-lg hover:bg-muted/50 transition-colors relative group"
                >
                  <ShoppingBag className="w-5 h-5" />
                  <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 blur-xl rounded-full transition-opacity" />
                </button>
                <VacationToggle />
                <ThemeToggle />
              </div>
            </div>
          </div>
        </div>
      </header>

      <SideMenu 
        isOpen={showSideMenu} 
        onClose={() => setShowSideMenu(false)}
        notificationCount={0}
      />
    </>
  );
}